<template>
	<section
		class="left-sidebar container-elements-tableau-de-bord clear-after"
		:style="user ? '' : 'visibility: hidden'"
		:class="{ pro: isPro }">

		<template v-if="isPro">
      <div v-if="isOwnerColoc" class="un-tab-bord pro-subscriptions"
           :class="{ 'active': $route.name === 'DashboardProHomes' || $route.name === 'DashboardProSubscriptions'
              || $route.name === 'DashboardPreviewAdvert' || $route.name === 'DashboardProAdvert' || $route.name === 'DashboardProDocuments'
              || $route.name === 'DashboardProLeaseContract' || $route.name === 'DashboardProReports' }">
        <router-link tag="div" :to="{ name: 'DashboardSubscriptions', query: { home_id: $route.query.home_id } }"
                     title="Gérer votre logement">
          <span class="sscontainer">
            <span class="intitule">Mon logement</span>
            <span class="container-picto">
              <svgicon icon="renew"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
      <div v-else class="un-tab-bord pro-subscriptions"
           :class="{ 'active': $route.name === 'DashboardProHomes' || $route.name === 'DashboardProInvitation'
              || $route.name === 'DashboardPreviewAdvert' || $route.name === 'DashboardProSubscriptions'
              || $route.name === 'DashboardProAdvert' || $route.name === 'DashboardProDocuments'
              || $route.name === 'DashboardProLeaseContract' || $route.name === 'DashboardProReports' || $route.name === 'DashboardProDiagnostics' }">
        <router-link tag="div" :to="{ name: 'DashboardProHomes', query: { home_id: $route.query.home_id } }"
          title="Gérer vos biens">
          <span class="sscontainer">
            <span class="intitule">Mes biens</span>
            <span class="container-picto">
              <svgicon icon="renew"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
      <div v-if="isManager" class="un-tab-bord pro-subscriptions"
        :class="{ 'active': ['DashboardManagerSupport', 'DashboardManagerSupportTicket'].includes($route.name) }">
        <router-link tag="div" :to="{ name: 'DashboardManagerSupport', query: { home_id: $route.query.home_id } }"
                     title="Conciergerie">
          <span class="sscontainer">
            <span class="intitule">Conciergerie</span>
            <span class="container-picto">
              <svgicon icon="customer-service"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord meeting" v-if="hasMandate && hasAccessAgenda"
           :class="{ 'active': $route.name === 'DashboardMeeting'}">
        <router-link tag="div" :to="{ name: 'DashboardMeeting', query: { home_id: $route.query.home_id }}"
                     title="Mon agenda">
          <span class="sscontainer">
            <span class="intitule">Mon agenda</span>
            <span class="container-picto container-picto--agenda">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 34.77 45.5"><defs><clipPath id="clip-path" transform="translate(0.5 0.5)"><rect class="cls-1" width="33.78" height="44.5"/></clipPath></defs><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><g class="cls-2"><path class="cls-3" d="M29.25,3.43H23.81V.75a.75.75,0,0,0-1.5,0V3.43H11.46V.75a.75.75,0,0,0-1.5,0V3.43H4.52A4.53,4.53,0,0,0,0,8V40A4.53,4.53,0,0,0,4.52,44.5H29.25A4.53,4.53,0,0,0,33.77,40V8A4.52,4.52,0,0,0,29.25,3.43Zm3,36.55a3,3,0,0,1-3,3H4.53a3,3,0,0,1-3-3V8a3,3,0,0,1,3-3H10V6.07a1.75,1.75,0,1,0,1.5,0V4.93H22.32V6.07a1.75,1.75,0,1,0,1.5,0V4.93h5.44a3,3,0,0,1,3,3ZM11,7.65c0,.28-.5.28-.5,0a.25.25,0,0,1,.25-.25A.25.25,0,0,1,11,7.65Zm12.35,0c0,.28-.5.28-.5,0a.25.25,0,0,1,.25-.25A.25.25,0,0,1,23.32,7.65Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M20.11,26.58H8.23a.75.75,0,0,0,0,1.5H20.12a.75.75,0,1,0,0-1.5Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M20.11,32H8.23a.75.75,0,1,0,0,1.5H20.12a.75.75,0,1,0,0-1.5Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M20.11,21.16H8.23a.75.75,0,0,0,0,1.5H20.12a.76.76,0,0,0,.75-.75A.76.76,0,0,0,20.11,21.16Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M20.11,37.43H8.23a.75.75,0,1,0,0,1.5H20.12a.75.75,0,1,0,0-1.5Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M20.11,15.74H8.23a.75.75,0,0,0,0,1.5H20.12a.75.75,0,1,0,0-1.5Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M25.64,14.62a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,25.64,14.62Zm0,2.24a.37.37,0,0,1,0-.74.37.37,0,0,1,0,.74Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M25.64,20.05a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,25.64,20.05Zm0,2.23a.37.37,0,1,1,0-.74.37.37,0,0,1,0,.74Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M25.64,25.47a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,25.64,25.47Zm0,2.23a.37.37,0,1,1,0-.74.37.37,0,0,1,0,.74Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M25.64,30.89a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,25.64,30.89Zm0,2.23a.37.37,0,0,1,0-.74.37.37,0,0,1,.36.38A.35.35,0,0,1,25.64,33.12Z" transform="translate(0.5 0.5)"/><path class="cls-3" d="M25.64,36.31a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,25.64,36.31Zm0,2.23a.37.37,0,0,1,0-.74.37.37,0,0,1,.36.38A.35.35,0,0,1,25.64,38.54Z" transform="translate(0.5 0.5)"/></g></g></g></svg>					</span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord pro-contactrequests" v-else-if="hasAccessAgenda"
           :class="{ 'active': $route.name === 'DashboardProContactRequests' }">
        <router-link tag="div" :to="{ name: 'DashboardProContactRequests', query: { home_id: $route.query.home_id } }"
          title="Voir les demandes">
				<span class="sscontainer">
					<span class="intitule">Mes demandes</span>
					<span class="container-picto">
						<svgicon icon="request-contact" class="icon-request-contact"></svgicon>
					</span>
				</span>
        </router-link>
      </div>
      <div class="un-tab-bord matching"
           :class="{ 'active': ['DashboardUserMatching', 'DashboardHomeMatching', 'DashboardFavorites', 'DashboardFavoriteGroup'].includes($route.name) }">
        <router-link tag="div" :to="{ name: isPro ? 'DashboardUserMatching' : 'DashboardHomeMatching', query: { home_id: $route.query.home_id, filters: undefined } }"
          title="Consulter les profils du matching">
          <span class="sscontainer">
            <span class="intitule">Mon matching</span>
            <span class="container-picto">
              <svgicon icon="picto-tablo-bord-matching"></svgicon>
              <span v-if="nbMatching !== 0"
                class="bulle-tablo-bord">{{ nbMatching }}</span>
            </span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord sidebar-messagerie"
           :class="{ 'active': ['DashboardMessages'].includes($route.name) }">
        <router-link tag="div" :to="{ name: 'DashboardMessages', query: { home_id: $route.query.home_id } }"
                     title="Consulter vos messages">
          <span class="sscontainer">
            <span class="intitule">Ma messagerie</span>
            <span class="container-picto">
              <svgicon icon="picto-tablo-bord-messagerie"></svgicon>
              <span
                v-if="nb_unread !== 0"
                class="bulle-tablo-bord">{{ nb_unread }}</span>
            </span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord sidebar-support"
           :class="{ 'active': ['DashboardSupport', 'DashboardSupportTicket'].includes($route.name) }">
        <router-link tag="div" :to="{ name: 'DashboardSupport', query: { home_id: $route.query.home_id } }"
                     title="Service Client">
          <span class="sscontainer">
            <span class="intitule">Service Client</span>
            <span class="container-picto">
              <svgicon icon="customer-service"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord profil"
           :class="{ 'active': $route.name === 'DashboardProfile' || $route.name === 'DashboardEdition'
              || $route.name === 'DashboardAccount' || $route.name === 'DashboardAccountEdition' }">
        <router-link tag="div" :to="{ name: isPro ? 'DashboardAccount' : 'DashboardProfile' }"
          title="Compléter, modifier vos coordonées de profil">
          <span class="sscontainer">
            <span class="intitule">{{ isPro ? 'Mon compte' : 'Profil' }}</span>
            <span class="container-picto">
              <svgicon icon="picto-tablo-bord-profil"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
      <div class="un-tab-bord parametres" :class="{ 'active': $route.name === 'DashboardParameters' }">
        <router-link tag="div" :to="{ name: 'DashboardParameters' }"
          title="Compléter, modifier vos paramètres">
          <span class="sscontainer">
            <span class="intitule">Paramètres</span>
            <span class="container-picto">
              <svgicon icon="picto-tablo-bord-parametres"></svgicon>
            </span>
          </span>
        </router-link>
      </div>
		</template>

		<template v-else>
      <div class="un-tab-bord" :class="{
            [item.class]: item.class,
            'active': item.active_routes.indexOf($route.name) !== -1,
           }"
           v-for="(item, index) of items" :key="index">
        <a v-if="typeof item.to === 'string' && (item.to.startsWith('https://') || item.to.startsWith('http://'))" :href="item.to"
           :title="item.title">
          <span class="sscontainer">
            <span class="intitule">{{ item.title }}</span>
            <span class="container-picto">
              <svgicon :icon="item.icon"></svgicon>
              <template v-if="item.count_info">
                <span class="bulle-tablo-bord">{{ item.count_info }}</span>
              </template>
            </span>
          </span>
        </a>
        <router-link v-else tag="a" :to="item.to"
          :title="item.title"
          :class="{
              'active': item.active_routes.indexOf($route.name) !== -1,
            }">
          <span class="sscontainer">
            <span class="intitule">{{ item.title }}</span>
            <span class="container-picto">
              <svgicon :icon="item.icon"></svgicon>
              <template v-if="item.count_info">
                <span class="bulle-tablo-bord">{{ item.count_info }}</span>
              </template>
            </span>
          </span>
        </router-link>
      </div>
		</template>
	</section>
</template>

<script>
import { eventBus } from '@/main'
import unreadCountMixin from '../mixins/unreadCount'

export default {
  mixins: [unreadCountMixin],
  name: 'dashboard-sidebard',
  props: {
    extraMatching: {
      type: Number,
      default: -1,
    },
    isPro: {
      type: Boolean,
    },
    user: {
      type: Object,
      required: true,
    },
    home: Object,
  },
  data: () => ({
    userData: {
      nbrMatching: 0,
      nbrFavoris: 0,
    },
    hasMandate: false,
    hasAccessAgenda: false,
  }),
  created() {
    this.hasMandate = this.home && this.home.mandate_status === 'complete'
    this.hasAccessAgenda = this.isOwner || (this.home && (this.home.notifications_agenda === 2 || this.home.notifications_agenda === 3 || (this.home.notifications_agenda === 0 && this.home.offer === 'mandate-79')))
    eventBus.$on('homeChanged', h => {
      this.hasMandate = h && h.mandate_status === 'complete'
      this.hasAccessAgenda = this.isOwner || (h && (h.notifications_agenda === 2 || h.notifications_agenda === 3 || (h.notifications_agenda === 0 && h.offer === 'mandate-79')))
    })
  },
  mounted() {
    if (this.user && this.user.type !== undefined) {
      this.load()
    }
  },
  methods: {
    load() {
      const user = this.user

      if (user.search && user.search.id && user.search.id.replace(/[0-]/g, '') !== '') {
        this.$http.get('/api/match/user-match-users?count=true').then(
          response => {
            this.userData.nbrMatching = response.data.HitsCount
          },
          err => {
            console.error(err)
          },
        )
      }

      if (user.type === 1) {
        this.$http.get('/api/accordances?counter=1')
          .then(res => this.userData.nbrFavoris = res.data)
          .catch(err => console.error(err.response)) // Ignore
      } else {
        this.$http.get(`/api/homes/accordances/${this.$route.query.home_id || 'default'}?counter=1`)
          .then(res => this.userData.nbrFavoris = res.data.Count)
          .catch(err => console.error(err.response)) // Ignore
      }

      if (user.type !== 1) {
        this.$http.get(`/api/homes/${this.$route.query.home_id || 'default'}/nb-matching-v4`).then(
          response => {
            this.userData.nbrMatching = response.data
          },
          err => {
            const code = err.response && err.response.data && err.response.data.error ? err.response.data.error.split('\n') : null
            if (code && code[0] === 'no_mandate') {
              this.userData.nbrMatching = code[2]
            }
            console.error(err)
          },
        )
      }
    },
  },
  computed: {
    isOwner() {
      return this.user && (this.user.type === 2 || this.user.type === 4 ||
        (this.user.type === 1 && this.user.home && !this.user.home.is_coloc))
    },
    isManager() {
      return this.user.type === 8
    },
    isOwnerColoc() {
      return this.user.type === 1 && this.user.home && !this.user.home.is_coloc
    },
    nbMatching() {
      let nbMatching = this.extraMatching >= 0 ? this.extraMatching : this.userData.nbrMatching
      nbMatching = parseInt(nbMatching)
      if (nbMatching + '' === 'NaN') {
        nbMatching = 0
      }
      return nbMatching
    },
    // Menu items for colocs
    items() {
      if (!this.user) return []
      const res = [
        {
          title: 'Ma co-location',
          icon: 'maison',
          to: { name: this.user && (!this.user.home || this.user.home.step >= 3) ? 'DashboardMyColocation' : 'DashboardProAdvert' },
          active_routes: [
            'DashboardMyColocation', 'DashboardColocReceipts', 'DashboardColocInvoices', 'DashboardColocDocuments',
            'DashboardProSubscriptions', 'DashboardProAdvert', 'DashboardProDiagnostics', 'DashboardProDocuments', 'DashboardProReports', 'DashboardColocTenantApplicants',
          ],
        },
        !(this.user.home && !this.user.home.is_coloc) ? {
          title: 'Mon dossier',
          icon: 'logo-oo',
          to: this.user && this.user.search && this.user.search.warranty_link ? this.user.search.warranty_link + '/dashboard' : { name: 'DashboardWarranty' },
          active_routes: ['DashboardWarranty', 'WarrantyConfirm'],
          class: 'sidebar-warranty',
        } : null,
        this.user.home_leased ? null
          : {
            title: 'Mon matching',
            icon: 'picto-profil-situation-8',
            to: { name: 'DashboardUserMatching' },
            active_routes: ['DashboardHomeMatching', 'DashboardUserMatching', 'DashboardViewAdvert',
              'DashboardFavorites', 'DashboardFavoriteGroup', 'DashboardSearch'],
            count_info: this.nbMatching,
            class: 'sidebar-matching',
          },
        {
          title: 'Mes rendez-vous',
          icon: 'calendar-icon',
          to: { name: 'DashboardMeeting' },
          active_routes: ['DashboardMeeting'],
          class: 'sidebar-agenda',
        },
        {
          title: 'Ma messagerie',
          icon: 'picto-tablo-bord-messagerie',
          to: { name: 'DashboardMessages' },
          active_routes: ['DashboardMessages'],
          count_info: this.nb_unread,
          class: 'sidebar-messagerie',
        },
        {
          title: 'Service Client',
          icon: 'customer-service',
          to: { name: 'DashboardSupport' },
          active_routes: ['DashboardSupport'],
        },
        this.user.id !== '20e4201d-edfd-4471-bcaf-ac5be78ed7c5'
          ? null
          : {
            title: 'Service Client (Inès)',
            icon: 'picto-profil-rythme-vie-14',
            to: { name: 'DashboardCustomerService' },
            active_routes: ['DashboardCustomerService'],
          },
        {
          title: 'Mon compte',
          icon: 'picto-tablo-bord-profil',
          to: { name: 'DashboardProfile' },
          active_routes: ['DashboardProfile', 'DashboardEdition', 'DashboardAccount', 'DashboardParameters'],
        },
      ]

      return res.filter(v => v !== null)
    },
  },
  watch: {
    '$route.query.home_id'() {
      this.userData = {
        nbrMatching: 0,
        nbrFavoris: 0,
      }
      this.load()
    },
    'user'() {
      this.load()
    },
  },
}
</script>

<style lang="scss">
.left-sidebar.pro {
	a, div.un-tab-bord {
		.sscontainer {
			height: 100%;
			.intitule {
				font-size: 1.26em;
        font-weight: 400;
				font-style: italic;
				color: $gray3;
			}
			.container-picto {
				margin-top: 10px;
				svg {
					height: 48px;
					width: 48px;
				}
			}
		}
		&.active, &:hover {
			background-color: $blue;
      border-color: $blue;
			.sscontainer {
				background-color: $blue;
				.intitule {
					color: white;
				}
        .container-picto svg path {
          fill: white;
        }
			}
		}

		@media #{$tablet} {
			.sscontainer {
				padding: 0;
				height: 45px;
				width: 45px;

				.container-picto {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100% !important;
					height: 100% !important;

					svg {
						height: 25px;
						width: 100%;
					}
					.icon-request-contact {
						height: 20px;
					}
				}
				.bulle-tablo-bord {
					right: 0;
				}
			}
		}
	}

	/*********************************************************************************************************************************************************/
	/* TABLET & PHONE
	/*********************************************************************************************************************************************************/
	@media #{$tablet} {
		padding: 0 5%;
		height: 60px;
		align-items: center;

		a, div.un-tab-bord, .pro div.un-tab-bord {
			height: unset;
			margin-bottom: 0;
			border-radius: 50% !important;

			.sscontainer {
				border-radius: 50% !important;

				.container-picto {
					height: 48px;
					width: 48px;
					margin-top: 0px;

					&--agenda {
						display: flex;
						align-content: center;
						justify-content: center;

						svg {
							height: 38px;
							width: 38px;
						}
					}
				}
			}
			&.sidebar-matching .sscontainer .container-picto svg {
				padding-left: 4px;
				padding-bottom: 2px;
			}
		}
		a.active, a:hover {
			border-color: $blue;
      .sscontainer {
        .intitule {
          color: white;
        }
        .container-picto svg path {
          fill: white !important;
        }
      }
		}
	}
}

// Warranty icon colors / size
.un-tab-bord.sidebar-warranty {
	path {
		fill: $red;
	}
	&:hover, &.active {
		path {
			fill: #FFF;
		}
	}

	@media #{$tablet} {
		path {
			fill: gray;
		}
		&:hover, &.active {
			path {
				fill: $red;
			}
		}
	}
}
.agenda {
	width: 40px;
}

@media #{$tablet} {
	.un-tab-bord {
		// Warranty icon position on mobile
		order: 2;

		&.sidebar-matching {
			order: 0;
		}
		&.sidebar-warranty {
			order: 1;
			.svg-icon {
				width: 45px;
			}
		}
		&.sidebar-agenda {
			order: 0;
			.agenda {
				width: 45px;
				height: 45px;
			}
		}

		// Matching icon size
		&.sidebar-matching .svg-icon {
			width: 40px;
		}
	}
}
</style>
